/**
 * @(#)2019/6/17.
 * YxPanel，折叠面板
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import YxPanel from "./YxPanel";
import PropTypes from "prop-types";
import { IStyleParam } from "../../utils/propType";
export const IYxPanelPropTypes = {
  //扩展的头部，跟随子标题
  extraHeader: PropTypes.node,

  //组件的样式类型
  styleType: PropTypes.string,

  // 面板头部信息，如果为false隐藏头部
  header: PropTypes.node,

  //是否允许内容区滚动,该属性如果设置为true，必须设置contentHeight
  isContentScroll: PropTypes.bool,

  //样式类型
  styleParam: IStyleParam,

  //是否展开
  isFold: PropTypes.bool,

  //是否禁用面板折叠操作
  disabled: PropTypes.bool,

  //面板折叠或打开后的回调
  change: PropTypes.func,

  //是否显示右边图标
  showArrow: PropTypes.bool,

  // 初始化否展开，默认true
  defaultValue: PropTypes.bool,

  // 自定义右边图标，isActive指是否折叠参数
  // 比如  ({ isActive }) => <Icon type="caret-right" rotate={isActive ? 90 : 0} />
  expandIcon: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  //可给头部自定义样式
  headerStyleParam: PropTypes.object,

  //自定义右上角内容
  extra: PropTypes.node,
  //底部栏的内容
  footerNode: PropTypes.node,

  //副标题
  subheading: PropTypes.node,

  // 面板容器div的参数
  containerParam: PropTypes.object,

  //表格文字的自定义图标 值为antd的icon的type
  headerTextIcon: PropTypes.string,

  children: PropTypes.node,
};
YxPanel.propTypes = IYxPanelPropTypes;
//默认参数
YxPanel.defaultProps = {
  headerTextIcon: "",
  styleParam: {
    type: "default", //类型   default/border/nonegPadding
    // size:"default", //大小  default/border
  },
  isContentScroll: false, //是否允许内容区滚动,该属性如果设置为true，必须设置contentHeight
  contentHeight: "", //内容区高度
  className: "", //className
  header: "", //title信息,如果空，则隐藏头部
  subheading: "", //副标题
  disabled: null,
  change: () => {}, //面板发生折叠时的回调函数
  showArrow: false, //是否显示右边图标
  expandIcon: "", //自定义图标
  extra: "", //自定义右上角内容
  isFold: false, //是否允许折叠
  children: "", //子节点
  footerNode: "", //底部栏的内容
  defaultValue: true, //默认是否展开
  forceRender: false, //折叠是否渲染节点
  containerParam: {},
  deep: false,
};

export default YxPanel;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxPanel/index.js